<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'성장 리포트'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="padding-bottom: 10px;">
            <div style="display: flex; padding: 0 12px;">
                <div :class="curTab === CUR_TAB.BOON ? 'active' : ''" @click="setCurTab(CUR_TAB.BOON)" class="tab_btn">등급 혜택</div>
                <div :class="curTab === CUR_TAB.RANK ? 'active' : ''" @click="setCurTab(CUR_TAB.RANK)" class="tab_btn">랭킹</div>
            </div>
        </div>
        <div v-if="curTab === CUR_TAB.BOON" style="flex: 1; overflow-y: scroll; margin-top: 15px; padding: 0 12px;">
            <div style="border: 1px solid #FED1A0; padding: 15px 20px; border-radius: 20px; background: #FFF6EA;">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <div> 
                            <img v-if="myGradeImagePath" style="width: 37px;" :src="$resourcePath + myGradeImagePath" alt="">
                        </div>
                        <div>
                            <div style="font-weight: 500; font-size: 12px; line-height: 20px; color: #808080;">나의 현재 등급</div>
                            <div style="font-weight: 700; font-size: 24px; line-height: 30px;">{{ myGradeName }}</div>
                        </div>
                    </div>
                    <div style="font-weight: 700; font-size: 32px; line-height: 30px;">{{ totalPoint }}P</div>
                </div>
                <div style="margin-top: 25px;">
                    <div style="background-color: #d9d9d9; height: 10px; border-radius: 12px;">
                        <div :style="{width: remainPercent + '%'}" style="border-radius: 12px; position: relative; background-color: var(--color-main); height: 100%;">
                            <div :style="{ right: remainPercent <= 2 ? '-28px' : '-17px' }" style="position: absolute; top: -16px;">
                                <img style="width: 45px;" :src="require('@/assets/img/current_point_shoe.png')" alt="">
                            </div>
                        </div>
                    </div>
                    <div style="display: flex; justify-content: space-between; margin-top: 2px;">
                        <div style="line-height: 16px; font-size: 12px; font-weight: 700;">오늘 획득 포인트 {{ todayPoint }}P</div>
                        <div style="line-height: 16px; font-size: 12px; font-weight: 700; color: #a2a2a2;">{{ nextPlayer }}</div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 20px;">
                <div style="display: flex; gap: 5px; align-items: center;">
                    <div>
                        <img style="width: 16px;" :src="require('@/assets/img/calendar_black.png')" alt="">
                    </div>
                    <div style="font-weight: 700; line-height: 20px;">이번 주 출석 체크</div>
                    <div style="background-color: #ececec; border-radius: 4px; padding: 2px 6px; line-height: 16px; font-weight: 500; font-size: 12px;">출석 시 <span style="color: var(--color-main);">+5p</span></div>
                </div>
                <div style="margin-top: 27px; display: flex; justify-content: space-between; margin-bottom: 2px; padding: 0 24px;">
                    <div v-for="each, i in thisWeekAttendance" :key="i" class="common_box">
                        <!-- <div style="color: red; font-size: 12px; font-weight: 500; position: absolute; top: -18px;" v-if="today === each.date">Today</div> -->
                        <template v-if="thisWeekAttendance.length > 0">
                            <div :style="{ color: each.date === today ? 'var(--color-main)' : '#8e9db2' }" style="font-size: 12px; font-weight: 500; margin-top: 5px; line-height: 16px;">{{ each.day }}</div>
                            <div :class="[setBoxClass(each.isBeforeToday, each.isAttend), setTodayClass(each.date, each.isAttend)]" class="check_date">
                                <img style="width: 10px;" v-if="each.date === today && each.isAttend" :src="require('@/assets/img/white_check.png')" alt="">
                                <img style="width: 10px;" v-else-if="each.isAttend && each.isBeforeToday" :src="require('@/assets/img/check_orange_round.png')" alt="">
                                <div v-else-if="!each.isAttend && each.isBeforeToday" style="width: 9px; height: 1px; background-color: #8E9DB2;"></div>
                            </div>
                            <!-- <div style="font-size: 12px; font-weight: 500; margin-top: 8px; line-height: 16px; white-space: nowrap;">{{ each.date.split('-')[2] }}일</div> -->
                        </template>
                    </div>
                </div>
            </div>
            <div style="margin-top: 32px;">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                    <div style="font-weight: 700; line-height: 16px;">포인트 더 모으기</div>
                    <div style="font-weight: 700; font-size: 12px; color: #8999AF;">옆으로 넘겨보세요 →</div>
                </div>
            </div>
            <div style="margin: 0 -12px;">
                <div style="display: flex; gap: 15px; padding: 20px 12px; overflow-x: scroll;" class="hide_scroll">
                    <div v-for="each, i in accumulationList" :key="i + 'grade_list'" style="border: 1px solid #EFF4F8; box-shadow: 1px 1px 4px 0px #00000033; border-radius: 12px; padding: 12px; font-weight: 700; width: 145px; height: 145px; flex-shrink: 0;">
                        <div>
                            <img style="width: 40px;" :src="$resourcePath + each.image_path" alt="">
                        </div>
                        <div style="margin-top: 20px; font-size: 14px; line-height: 16px; white-space: nowrap;">{{ each.description }}</div>
                        <div style="font-size: 12px; color: #606060; line-height: 16px; margin-top: 4px;">{{ each.sub_description }}</div>
                        <div style="border-radius: 4px; background-color: #fff6ea; padding: 0 8px; line-height: 16px; font-size: 12px; color: var(--color-main); margin-top: 4px; display: inline-block;">+ {{ each.point }}P</div>
                    </div>
                </div>
            </div>
            <div>
                <div style="font-weight: 700; line-height: 16px;">최근 활동</div>
                <div v-for="each, i in recentActivity" :key="i + 'recent_active'" style="border-bottom: 1px solid #f5f5f5; padding: 15px 0;">
                    <RecentActivityWrap :recentActivityEach="each"></RecentActivityWrap>
                </div>
                <div @click="showActivityHistory" style="margin: 0 auto; margin-top: 12px; width: 155px; height: 40px; line-height: 40px; text-align: center; border: 2px solid #210F031A; font-size: 14px; font-weight: 500; border-radius: 10px;">활동 내역 더보기</div>
            </div>
            <div style="margin-top: 20px;">
                <div style="font-weight: 700; line-height: 16px;">등급 안내</div>
                <div style="margin-top: 15px;">
                    <div v-for="each, i in gradeList.toReversed()" :key="i + 'grade'" :class="setBackgronud(each.name)" style="border-radius: 12px; display: flex; margin-bottom: 20px; padding: 15px 25px;">
                        <div style="display: flex; align-items: center; gap: 12px; flex: 1;">
                            <div>
                                <img style="width: 30px;" :src="$resourcePath + each.image_path" alt="">
                            </div>
                            <div style="flex: 1;">
                                <div :style="{color: each.name === myGradeName ? 'var(--color-main)' : ''}" style="font-weight: 700; line-height: 20px; display: flex; align-items: center; gap: 4px;">
                                    {{ each.name }}
                                    <span v-if="each.name === myGradeName" style="display: inline-block; width: 25px; height: 16px; line-height: 16px; text-align: center; color: #fff; font-weight: 700; font-size: 12px; background-color: var(--color-main); border-radius: 30px;">MY</span>
                                </div>
                                <div style="font-weight: 500; font-size: 12px; color: #808080;">
                                    <div v-if="each.idx == 1" style="font-size: 12px; line-height: 20px;">가입 즉시 부여</div>
                                    <div style="line-height: 20px;" v-else-if="each.idx != 4">{{ each.min_point + ' P 이상' }}</div>
                                    <div style="line-height: 20px;" v-else>{{ each.min_point + 'P 이상' }}</div>
                                </div>
                            </div>
                            <div style="color: #808080; font-weight: 700;">
                                <div v-if="each.idx == 4">MAX</div>
                                <div v-else>{{ '~ ' + each.max_point }}P</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 20px; margin-bottom: 20px;">
                <ul style="font-weight: 700; color: #bcbcbc; font-size: 12px; display: flex; flex-direction: column; align-items: center;">
                    <li style="line-height: 20px;">등급은 누적 획득 포인트를 기준으로 실시간 반영됩니다.</li>
                    <li style="line-height: 20px;">등급 혜택은 추후에 업데이트 될 예정입니다.</li>
                </ul>
            </div>
        </div>
        <div v-else style="flex: 1; overflow-y: scroll; margin-top: 15px; padding: 0 12px; position: relative;">
            <div style="">
                <div style="font-weight: 700; font-size: 24px; line-height: 24px; text-align: center;">사커하우 주급 랭킹 🏃🏻</div>
                <div style="display: flex; justify-content: center; margin-top: 12px; font-weight: 700; font-size: 12px; color: #808080; align-items: center; gap: 12px;">
                    <div style="line-height: 24px;">누적 주급 포인트</div>
                    <div style="width: 2px; height: 16px; background-color: #d9d9d9;"></div>
                    <div style="line-height: 24px;">{{ current_date_time }} 기준</div>
                    <div style="width: 2px; height: 16px; background-color: #d9d9d9;"></div>
                    <div style="line-height: 24px;">실시간 업데이트</div>
                </div>
                <div style="margin-top: 4px; font-weight: 500; line-height: 20px; text-align: center; padding-bottom: 12px;">열심히 활동하고 주급 포인트를 쌓아보세요.</div>
                <div style="margin-top: 10px;">
                    <div style="display: flex; justify-content: center; gap: 40px;">
                        <div style="display: flex; flex-direction: column; align-items: center;" :style="{ order: getOrder(each.rank_no)}" v-for="each, i in rankingList.slice(0, 3)" :key="i + 'top_rank'">
                            <div :style="{ background: setBorderLine(each.rank_no), marginTop: each.rank_no != 1 ? '25px' : '' }" style="width: 74px; height: 74px; padding: 2px; border-radius: 50%;">
                                <ProfileImage :isShowBorder="false" style="width: 100%;" :imagePath="each.image_path"></ProfileImage>
                            </div>
                            <div style="text-align: center; ">
                                <div style="margin-top: -5px;">
                                    <img style="width: 30px;" :src="require(`@/assets/img/rank${each.rank_no}.png`)" alt="">
                                </div>
                                <div style="font-weight: 700; line-height: 20px;">{{ each.nic_name }}</div>
                                <div style="font-weight: 700; line-height: 20px; color: var(--color-main);">{{ each.point | comma }} P</div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 16px; margin-bottom: 130px;">
                        <div style="font-weight: 700; font-size: 12px; color: #808080;">전체 주급 순위</div>
                        <div v-for="each, i in rankingList.slice(3)" :key="i + 'rank'" class="rank_box">
                            <div>
                                <div style="font-weight: 700;">{{ each.rank_no }}</div>
                                <div>
                                    <img v-if="parseInt(each.rank_diff) < 0 || !each.rank_diff" style="width: 8px;" :src="require('@/assets/img/down_rank.png')" alt="">
                                    <img v-else-if="parseInt(each.rank_diff) > 0" style="width: 8px;" :src="require('@/assets/img/up_rank.png')" alt="">
                                    <img v-else style="width: 8px;" :src="require('@/assets/img/maintain_rank.png')" alt="">
                                </div>
                            </div>
                            <div style="flex: 1; display: flex; align-items: center; gap: 8px;">
                                <div style="width: 30px; height: 30px; border-radius: 50%; border: 1px solid #808080">
                                    <ProfileImage :isShowBorder="false" style="width: 100%;" :imagePath="each.image_path"></ProfileImage>
                                </div>
                                <div style="display: flex; align-items: center; gap: 4px; font-weight: 700;">
                                    <div>{{ each.nic_name }}</div>
                                    <div style="color: var(--color-main);">{{ each.position }}</div>
                                </div>
                            </div>
                            <div style="font-weight: 700;">
                                <div style="line-height: 16px; text-align: right;">{{ each.point | comma }}</div>
                                <div style="color: #808080; font-size: 12px; font-weight: 500; line-height: 16px; margin-top: 4px;">Point</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="myRanking" style="position: fixed; opacity: 0.95; padding: 0 12px; width: 100%; bottom: 20px; left: 50%; transform: translateX(-50%);">
                <div style="background: linear-gradient(90deg, #EBEBEB 0%, #F9DDC7 100%); padding: 16px; border-radius: 12px;">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px; margin-bottom: 8px;">내 랭킹</div>
                    <div style="display: flex; align-items: center;">
                        <div style="font-size: 14px; width: 25px; font-weight: 900; color: #606060; line-height: 24px; text-align: center;">{{ myRanking.rank_no }}</div>
                        <div style="width: 30px;">
                            <ProfileImage style="width: 100%;" :imagePath="myRanking.image_path"></ProfileImage>
                        </div>
                        <div style="display: flex; align-items: center; flex: 1; gap: 4px; margin-left: 5px;">
                            <div style="font-weight: 700; line-height: 24px;">{{ myRanking.nic_name }}</div>
                            <div v-if="myRanking.is_temp_coach == 0" style="font-weight: 900; font-size: 15px; color: var(--color-main);">{{ myRanking.position }}</div>
                        </div>
                        <div style="display: flex; gap: 4px;">
                            <div style="line-height: 24px; font-weight: 700;">{{ myRanking.point }}</div>
                            <div style="line-height: 24px; font-weight: 700; font-size: 14px; color: #808080;">Point</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ProfileImage from '@/components/common/ProfileImage'
import moment from 'moment'
import RecentActivityWrap from '@/components/common/RecentActivityWrap';

const CUR_TAB = {
    BOON: '혜택',
    RANK: '랭킹'
}

const GRADE_NAME = {
    BALL_BOY: '볼보이',
    RISING_STAR: '유망주',
    ACE: '에이스',
    WORLD_CLASS: '월드클래스'
}

export default {
    name: 'GrowthReport',
    components: { 
        MercenaryHeader, RecentActivityWrap, ProfileImage
    },
    async created() {
        this.current_date_time = this.$Util.getMDDHangulStr(moment().format('YYYY-MM-DD'));

        await Promise.all([
            this.getGradeInfo(),
            this.getMenuList(),
            this.getPointRank()
        ])
        this.setGradeInfo()
    },
    data() {
        return {
            today: moment().format('YYYY-MM-DD'),
            curTab: CUR_TAB.BOON,
            CUR_TAB: CUR_TAB,
            gradeList: [],
            accumulationList: [],
            totalPoint: 0,
            todayPoint: 0,
            monthNumber: 0,
            weekString: '',
            myGradeImagePath: '',
            myGradeName: '',
            thisWeekAttendance: [],
            nextPlayer: '',
            remainPoint: 0,
            remainPercent: 0,
            recentActivity: [],
            current_date_time: '',
            rankingList: [],
            myRanking: null
        }
    },
    methods: {
        showActivityHistory() {
            this.$GlobalStore.addModal('ActivityHistory')
        },
        getOrder(rankNo) {
            // 1등을 가운데(두 번째)로
            if (rankNo == 1) return 2
            if (rankNo == 2) return 1
            if (rankNo == 3) return 3
        },
        setBorderLine(rank_no) {
            let transRankNo = parseInt(rank_no)

            if (transRankNo === 1) {
                return 'linear-gradient(180deg, #D39401 0%, #F9D511 100%)'
            } else if (transRankNo === 2) {
                return 'linear-gradient(180deg, #808080 0%, #A2A2A2 100%)'
            } else {
                return 'linear-gradient(180deg, #7B2B02 0%, #AA5A22 100%)'
            }
            
        },
        async getPointRank() {
            const res = await this.$Axios.get('/api/membership/point/rank')
            const rankingList = res.data.rankings

            this.rankingList = rankingList

            this.rankingList.forEach(item => {
                if (item.member_idx == this.$GlobalStore.loginInfo().idx) {
                    this.myRanking = item
                }
            })
        },  
        setBackgronud(gradeName) {
            if (gradeName === this.myGradeName) {
                return 'my_grade'
            } else {
                return 'common_grade'
            }
        },
        setBoxClass(isBeforeToday, isAttend) {
            if (isBeforeToday) {
                if (isAttend) {
                    return 'attend'
                } else {
                    return 'absence'
                }
            } else {
                return 'after'
            }
        },
        setTodayClass(date, isAttend) {
            if (date === this.today && isAttend) {
                return 'today'
            }
        },
        setCurTab(tab) {
            this.curTab = tab
        },
        async getMenuList() {
            const res =  await this.$Axios.get('/api/membership/menu/list')

            const accumulationList = res.data.accumulation_list
            const grade_list = res.data.grade_list

            this.accumulationList = accumulationList
            this.gradeList = grade_list
        },
        setGradeInfo() {
            const transTotalPoint = parseInt(this.totalPoint)
            const gradeInfo = this.beforeSetGradeInfo(transTotalPoint)

            this.nextPlayer = gradeInfo.nextPlayer
            this.remainPoint = gradeInfo.remainPoint
            this.myGradeImagePath = gradeInfo.imagePath
            this.myGradeName = gradeInfo.gradeName
            this.remainPercent = gradeInfo.remainPercent
        },
        beforeSetGradeInfo(transTotalPoint) {
            let gradeIndex = 0     

            if (transTotalPoint >= 900) {
                gradeIndex = 3
            } else if (transTotalPoint >= 400) {
                gradeIndex = 2
            } else if (transTotalPoint >= 100) {
                gradeIndex = 1
            }

            const currentGrade = this.gradeList[gradeIndex]
            const nextGrade = this.gradeList[gradeIndex + 1] ?? currentGrade

            const nextMinPoint = parseInt(nextGrade.min_point)

            const remainPoint =
                gradeIndex < this.gradeList.length - 1
                    ? nextMinPoint - transTotalPoint
                    : 0

            const progressPercent =
                gradeIndex < this.gradeList.length - 1
                    ? Math.min((transTotalPoint / nextMinPoint) * 100, 100)
                    : 100

            return {
                gradeIndex,
                imagePath: currentGrade.image_path,
                gradeName: Object.values(GRADE_NAME)[gradeIndex],
                nextPlayer: nextGrade.name,
                remainPoint,
                remainPercent: progressPercent
            }
        },
        async getGradeInfo() {
            const res = await this.$Axios.get('/api/membership/grade_info')
            const totalPoint = res.data.point_info[0].point
            const todayPoint = res.data.point_info[0].today_point === null ? 0 : res.data.point_info[0].today_point
            const renet_activity = res.data.recent_activity

            this.totalPoint = totalPoint
            this.todayPoint = todayPoint
            this.recentActivity = renet_activity

            const attendedDates = res.data.weekly_attendance.map(item => 
                moment(item.insert_date).format('YYYY-MM-DD')
            )

            this.getAttendanceList(attendedDates)
            this.getWeekOfMonth()
        },
        getAttendanceList(attendedDates) {
            const weekDaysKR = ['일','월','화','수','목','금','토'];
            const thisWeekAttendance = []
            const startOfWeek = moment().startOf('week').add(1, 'day')
            const today = moment().format('YYYY-MM-DD')

            for (let i = 0; i < 7; i++) {
                const current = startOfWeek.clone().add(i, 'day');
                const date = current.format('YYYY-MM-DD');
                thisWeekAttendance.push({
                    date,
                    day: weekDaysKR[current.day()],
                    isAttend: attendedDates.includes(date),
                    isBeforeToday: date <= today
                })
            }
            this.thisWeekAttendance = thisWeekAttendance
        },
        getWeekOfMonth() {
            const thisMonthNumber = moment().month() + 1;
            const today = moment();
            const startOfMonth = moment().startOf('month');
            const firstMonday = startOfMonth.clone().day(1);

            const weekOfMonth = today.diff(firstMonday, 'weeks') + 1;
            const weekNames = ["첫째", "둘째", "셋째", "넷째", "다섯째"];

            const weekString = weekNames[weekOfMonth - 1] || `${weekOfMonth}째`;
            this.monthNumber = thisMonthNumber
            this.weekString = weekString
        }
    }
}
</script>

<style scoped>
.tab_btn {
    flex: 1; 
    text-align: center;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    border-bottom: 1px solid #d9d9d9;
    color: #909090;
}

.active {
    border-bottom: 2px solid var(--color-main);
    padding-bottom: 10px;
    color: var(--color-main);
}

.check_date {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #8e9db2;
    display: flex;
    justify-content: center;
    align-items: center;
}

.common_box {
    display: flex; 
    flex-direction: column; 
    align-items: center;
    position: relative;
    gap: 12px;
    /* background-color: #909090; */
}

.attend {
    background-color: #fff;
}

.after {
    border: 1px dashed #8E9DB2;
}

.absence {
    background-color: #EFF3F8
}

.today {
    background-color: var(--color-main);
    border: none;
}

.common_grade {
    border: 1px solid #d9d9d9; 
    background-color: #fff;
}

.my_grade {
    border: 1px solid #FED1A0;
    box-shadow: 1px 1px 2px 0px #00000033;  
    background: #FFF6EA;
}

.rank_box {
    box-shadow: 1px 1px 4px 0px #0000001A;
    margin-top: 10px; 
    padding: 14px; 
    border: 1px solid #F5F7FA; 
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
}
</style>